import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';

import { OldAmexNyseComponent } from './old-amex-nyse.component';
import { OldCegComponent } from './old-ceg.component';
import { OldNasdaqComponent } from './old-nasdaq.component';
import { OldAgreementsModalComponent } from './old-agreements.modal.component';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    WebbrokerCoreModule,
    TranslateModule.forChild()
  ],
  exports: [
    OldAgreementsModalComponent,
    OldAmexNyseComponent,
    OldCegComponent,
    OldNasdaqComponent
  ],
  declarations: [
    OldAgreementsModalComponent,
    OldAmexNyseComponent,
    OldCegComponent,
    OldNasdaqComponent
  ]
})
export class OldAgreementsModule {
}

export {
  OldAgreementsModalComponent,
  OldAmexNyseComponent,
  OldCegComponent,
  OldNasdaqComponent
};
